import React from 'react'
import { connect } from 'react-redux';

function OverviewFooter(props) {
  const { staff_attributes } = props;

  return (
    <footer>
      <h6>Authorized By:</h6>
      <div className="d-flex flex-column">
        {staff_attributes.signature_attributes ?
          <div className="py-2">
            <img className="img-fluid" style={{ height: '6rem' }} src={staff_attributes.signature_attributes.file.url} alt="Doctor Signature" signature />
          </div> :
          <em className="py-6 px-5 signature font-size-30">{staff_attributes.name}</em>
        }
        <div className="d-flex align-items-baseline">
          <h6 className="mr-4">{staff_attributes.name}</h6>
          <h6 className="mr-4">Lic #: </h6>
          <span className="mr-4">{staff_attributes.license_number}</span>
          <h6 className="mr-4">NPI: </h6>
          <span className="mr-4">{staff_attributes.npi}</span>
        </div>
      </div>
    </footer>
  )
}

const mapStateToProps = state => {
  const { exam } = state
  return {
    exam: exam.exam,
    staff_attributes: exam.exam.staff_attributes
  }
}

export default connect(mapStateToProps)(OverviewFooter);